import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ReferenceTransactionsComponent } from 'app/dialogs/reference-transactions/reference-transactions.component';
import { ReferenceService } from 'app/services/models/reference.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-reference-list',
  templateUrl: './reference-list.component.html',
  styleUrls: ['./reference-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferenceListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  constructor(
    private referenceService: ReferenceService,
    private modalService: NgbModal
  ) { }

  async ngOnInit() {
    this.referenceService.event$.subscribe(result => {
      this.getAllReference(this.pageBasic - 1, this.selectedSize);
    })
    this.getAllReference(this.pageBasic - 1, this.selectedSize);
  }

  async getAllReference(page, size) {
    const data = await this.referenceService.getAllReference(page, size);
    console.log(data);
    this.rows = data.references;
    this.totalCount = data.totalCount;
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllReference(this.pageBasic - 1, this.selectedSize);
  }

  async onPageChange() {
    await this.getAllReference(this.pageBasic - 1, this.selectedSize);
  }

  createReference() {
    const modal = this.modalService.open(ReferenceTransactionsComponent)
    modal.componentInstance.referenceId = null;
  }


  updateReference(id) {
    const modal = this.modalService.open(ReferenceTransactionsComponent)
    modal.componentInstance.referenceId = id;
  }
}